import React, { Component } from 'react'
import { Link } from 'react-router'
import isEqual from 'lodash.isequal'

import classNames from './QueueEditor.css'
import LoadingSpinner from '../LoadingSpinner'
import SortableList from './SortableList'
import SortableBar from './SortableBar'
import PlaylistPicker from './PlaylistPicker'
import LocationPicker from '../search/LocationPicker'
import { pluralize } from '../../utils/string'
import { getItemName } from './utils'
import { AUTO_PLAYLIST_SUFFIX } from '../../constants'

const BASE_STRUCTURE = {
  playlists: [],
  muted: []
}

function getStructure (props) {
  if (props.queue) {
    return {
      ...BASE_STRUCTURE,
      ...JSON.parse(props.queue.json_data)
    }
  }
  return BASE_STRUCTURE
}

export default class QueueEditor extends Component {
  state = {
    name: this.props.queue ? this.props.queue.name : '',
    structure: getStructure(this.props),
    conflicts: [],
    checkingForConflicts: false,
    conflictCheckError: null,
    saveSuccess: false,
    saving: false
  }
  // Used by queues page
  isUnsaved = () => {
    const { params, queue } = this.props
    const { name, structure } = this.state
    if (params.id && queue) {
      return (name && name !== queue.name) || isEqual(structure, JSON.parse(queue.json_data)) === false
    }
    return name && structure.playlists.length !== 0
  }
  componentWillReceiveProps (nextProps) {
    const { queue } = this.props
    if (!queue && nextProps.queue) {
      this.setState({
        name: nextProps.queue.name,
        structure: getStructure(nextProps)
      })
    }
    if (queue && !nextProps.queue) {
      this.setState({
        name: '',
        structure: getStructure(nextProps)
      })
    }
    if (queue && nextProps.queue && queue.json_data !== nextProps.queue.json_data) {
      if (isEqual(this.state.structure, JSON.parse(queue.json_data))) {
        this.setState({
          name: nextProps.queue.name,
          structure: getStructure(nextProps)
        })
      }
    }
  }
  previewQueue = () => {
    const onError = e => {
      window.alert('There was an error loading the preview')
      console.log(e)
      this.setState({ loadingPreview: false })
    }
    this.setState({ loadingPreview: true })
    this.saveQueue().then(data => {
      console.log('queue saved', data)
      return this.props.sendToPlayNow(this.props.params.id)
    }).then(data => {
      console.log('channel opened', data)
      this.props.presentChannel(data.channel)
    }, onError)
  }
  onReorder = playlists => {
    const { structure } = this.state
    this.setState({
      conflicts: [],
      structure: {
        ...structure,
        playlists
      }
    })
  }
  deletePlaylist = index => {
    const { structure } = this.state
    const id = structure.playlists[index]
    this.setState({
      conflicts: [],
      structure: {
        ...structure,
        playlists: [
          ...structure.playlists.slice(0, index),
          ...structure.playlists.slice(index + 1)
        ],
        muted: structure.muted.filter(i => i !== id)
      }
    })
  }
  addPlaylist = id => {
    const { structure } = this.state
    this.setState({
      structure: {
        ...structure,
        playlists: structure.playlists.concat(id)
      }
    })
  }
  updateQueue = (key, value) => {
    const { structure } = this.state
    this.setState({
      structure: {
        ...structure,
        [key]: value
      }
    })
  }
  togglePlaylistMuted = id => {
    const { structure } = this.state
    if (structure.muted.indexOf(id) === -1) {
      this.updateQueue('muted', structure.muted.concat(id))
    } else {
      this.updateQueue('muted', structure.muted.filter(i => i !== id))
    }
  }
  saveQueue = () => {
    const { params, saveQueue } = this.props
    const { name, structure } = this.state
    const id = params.id === 'create' ? undefined : params.id
    this.preventSaveAlert = true
    this.setState({
      checkingForConflicts: false,
      conflictCheckError: null,
      saveSuccess: false,
      saving: true
    })
    return saveQueue({ name }, structure, id, params.id === 'create')
      .then(queue => {
        this.setState({
          checkingForConflicts: true,
          saveSuccess: true,
          saving: false
        })
        this.props.checkForConflicts(queue).then(response => {
          this.setState({
            conflicts: response.validation,
            checkingForConflicts: false
          })
        }, e => this.setState({
          checkingForConflicts: false,
          conflictCheckError: e
        }))
      })
  }
  deleteQueue = () => {
    if (window.confirm(`Are you sure you want to delete ${this.props.queue.name}?`)) {
      this.preventSaveAlert = true
      this.props.deleteQueue(this.props.queue.id)
    }
  }
  getCover = item => {
    const { entities, getImageSource } = this.props
    const album = entities.albums[item.album]
    if (!album) {
      return null
    }
    return (
      <div
        key={album.cover}
        className={classNames.cover}
        style={{ backgroundImage: `url(${getImageSource(album.cover, 'i')})` }}
      />
    )
  }
  renderPlaylistSubtitle (playlist, conflicts) {
    const albums = JSON.parse(playlist.json_data).albums
    return (
      <div>
        {pluralize(albums.length, 'album')}
        <br />
        {albums.map(this.getCover)}
        <br />
        {conflicts.map(this.renderConflict)}
      </div>
    )
  }
  renderPlaylist = (id, index) => {
    const { editPlaylist, entities } = this.props
    const playlist = entities.playlists[id]
    if (!playlist) {
      return (
        <SortableBar
          key={id}
          title='Deleted playlist'
          subtitle='This playlist has been deleted and should be removed from the queue'
          onRemove={() => this.deletePlaylist(index)}
          className={classNames.playlist}
        />
      )
    }
    const conflicts = this.state.conflicts.filter(c => c.playlist === index)
    const autoIndicator = playlist.name.indexOf(AUTO_PLAYLIST_SUFFIX) !== -1 ? <small key='auto'> (autoplaylist)</small> : null
    const name = playlist.name.replace(AUTO_PLAYLIST_SUFFIX, '')
    return (
      <SortableBar
        key={id}
        title={[ name, autoIndicator ]}
        subtitle={this.renderPlaylistSubtitle(playlist, conflicts)}
        muted={this.state.structure.muted.indexOf(id) !== -1}
        onMute={() => this.togglePlaylistMuted(playlist.id)}
        onEdit={() => editPlaylist(id)}
        onRemove={() => this.deletePlaylist(index)}
        className={classNames.playlist}
      />
    )
  }
  renderSettings () {
    const { structure } = this.state
    return (
      <div className={classNames.settings}>
        <label>
          Set location for dynamic links (if any)
          <select
            value={structure.locationOverride || undefined}
            onChange={e => this.updateQueue('locationOverride', e.target.value || undefined)}
          >
            <option value=''>Use locations set in albums</option>
            <option value='user'>Override all with default location ({this.props.userDefaultLocation})</option>
            <option value='custom'>Override all with custom location</option>
          </select>
        </label>
        {structure.locationOverride === 'custom' &&
          <LocationPicker
            value={structure.location || { lat: 51.5, lon: -0.13, address: 'London, UK' }}
            onChange={value => this.updateQueue('location', value)}
            hideMap
          />
        }
      </div>
    )
  }
  renderConflict = conflict => {
    return (
      <div className={classNames.conflict}>
        {typeof conflict.album === 'number' ? 'Album ' + (conflict.album + 1) : 'Playlist'}: {conflict.conflict}
      </div>
    )
  }
  render () {
    const { playlists, submitting, savePlaylist, albums } = this.props
    const { name, structure } = this.state

    const availablePlaylists = playlists.filter(p => structure.playlists.indexOf(p.id) === -1)

    let saveButton = (
      <button
        onClick={this.saveQueue}
        className={classNames.button}
        disabled={!name || structure.playlists.length === 0 || submitting}>
        {submitting ? 'Saving…' : 'Save Queue'}
      </button>
    )
    if (this.state.saveSuccess && !this.isUnsaved()) {
      saveButton = (
        <button onClick={() => window.history.back()} className={classNames.button}>
          Done
        </button>
      )
    }

    return (
      <div className={classNames.page}>
        {this.props.queue &&
          <button onClick={this.previewQueue} className={classNames.previewButton}>
            {this.state.loadingPreview ? 'Loading Preview…' : 'Preview Queue'}
          </button>
        }
        <div className={classNames.heading}>
          Queue Name
        </div>
        <input
          type='text'
          value={name}
          onChange={e => this.setState({ name: e.target.value })}
          autoFocus={!this.props.queue}
        />
        <div className={classNames.heading}>
          Playlists
        </div>
        {structure.playlists.length !== 0 &&
          <SortableList
            items={structure.playlists}
            renderItem={this.renderPlaylist}
            sortHandle='handle'
            onSort={this.onReorder}
            itemClass={classNames.album}
          />
        }
        <div className={classNames.pickerWrapper}>
          <PlaylistPicker
            playlists={availablePlaylists}
            albums={albums}
            onChange={this.addPlaylist}
            savePlaylist={savePlaylist}
            getImageSource={this.props.getImageSource}
          />
        </div>
        {this.renderSettings()}
        {this.props.queue &&
          <button
            onClick={this.deleteQueue}
            className={classNames.deleteButton}>
            Delete Queue
          </button>
        }
        {saveButton}
        <button onClick={() => window.history.back()} className={classNames.cancelButton}>
          Cancel
        </button>
        <small style={{ clear: 'both', float: 'right' }}>
          <span dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
          {this.state.checkingForConflicts &&
            'Checking for conflicts…'
          }
          {this.state.conflictCheckError &&
            'There was an error checking for conflicts'
          }
        </small>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/playlist/QueueEditor.js